export function isRichTextEmpty(html: string | undefined | null): boolean {
  if (!html) return true;
  const stripped = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim();
  return stripped === "";
}
